import { __require as i } from "./main34.js";
var e, r;
function n() {
  if (r) return e;
  r = 1;
  var t = i(), a = t(Object, "create");
  return e = a, e;
}
export {
  n as __require
};
